<template>

<div class="results">

	<com-headmain :simple="true" />

	<div class="results-content">

		<div class="results-title">{{ section.patient.title || section.text.title }}<div class="subsection-close" v-on:click="$emit('back')"></div></div>

		<div class="results-intro" v-if="section.intro" v-html="section.intro"></div>

		<template v-if="hasData">

			<div class="results-section" v-if="density !== false">
				<div class="results-section-title">{{ (section.density && section.density.title) || 'Bone Density Results' }}</div>
				<com-density :section="riskSection" :active="true" :completed="false" v-if="riskSection" />
			</div>

			<div class="results-section" v-if="score !== null">
				<div class="results-section-title">{{ (section.risk && section.risk.title) || 'Fracture Risk Score' }}</div>
				<div class="results-score">
					<div class="results-score-value">{{ score }}<small>in</small>100</div>
					<div class="results-score-percent"><span>{{ score }}%</span> chance of breaking a bone in the next 10 years</div>
				</div>
			</div>

		</template>

		<div class="results-nodata" v-if="!hasData">
			<i class="fa-solid fa-circle-info"></i>
			<div v-html="section.no_data || '<p>Some sections in My bone health are only available to people who have added personal health data to the tool.</p>'"></div>
		</div>

		<div class="results-explainers" v-if="section.frax || section.tscore || section.zscore">

			<div class="results-explainer" v-if="section.frax && section.frax.title" v-on:click="toggleExplainer('frax')" :class="{'is-active': explainer === 'frax'}">
				<div class="results-explainer-title">{{ section.frax.title }} <i class="fa-solid" :class="explainer === 'frax' ? 'fa-chevron-up' : 'fa-chevron-down'"></i></div>
				<div class="results-explainer-text" v-if="explainer === 'frax'" v-html="section.frax.text"></div>
			</div>

			<div class="results-explainer" v-if="section.tscore && section.tscore.title" v-on:click="toggleExplainer('tscore')" :class="{'is-active': explainer === 'tscore'}">
				<div class="results-explainer-title">{{ section.tscore.title }} <i class="fa-solid" :class="explainer === 'tscore' ? 'fa-chevron-up' : 'fa-chevron-down'"></i></div>
				<div class="results-explainer-text" v-if="explainer === 'tscore'" v-html="section.tscore.text"></div>
			</div>

			<div class="results-explainer" v-if="section.zscore && section.zscore.title" v-on:click="toggleExplainer('zscore')" :class="{'is-active': explainer === 'zscore'}">
				<div class="results-explainer-title">{{ section.zscore.title }} <i class="fa-solid" :class="explainer === 'zscore' ? 'fa-chevron-up' : 'fa-chevron-down'"></i></div>
				<div class="results-explainer-text" v-if="explainer === 'zscore'" v-html="section.zscore.text"></div>
			</div>

		</div>

		<com-check :text="section.text.title" v-on:click="$emit('next')" />

	</div>

</div>

</template>

<script>

import comHeadMain from './../../common/Head'
import comCheck from './common/Check'
import comDensity from './risk/Density'

export default {

	props: ['section'],

	components: {
		'com-headmain': comHeadMain,
		'com-check': comCheck,
		'com-density': comDensity
	},

	data: function() {

		return {
			explainer: false
		}

	},

	computed: {

		riskSection: function() {

			return this.$_.findWhere(this.$store.getters['data/aid/sections'], {
				type: 'risk'
			})

		},

		density: function() {

			var named = this.$store.getters['logic/variable/named']
			var id = named['ref.lowest']

			if (id === undefined) return false

			var score = this.$store.getters['session/values'][id]

			return (score === null || score === undefined) ? false : parseFloat(score).toFixed(1)

		},

		score: function() {

			var named = this.$store.getters['logic/variable/named']
			var mofId = named['system.1a'] || named['ref.mof']

			if (mofId === undefined) return null

			var value = this.$store.getters['logic/variable'](mofId)

			return (value !== null) ? Math.round(value) : null

		},

		hasData: function() {

			return this.density !== false || this.score !== null

		}

	},

	methods: {

		toggleExplainer: function(key) {

			this.explainer = (this.explainer === key) ? false : key

		}

	}

}

</script>

<style scoped>

.results {
	position: absolute;
	left: 300px;
	right: 0px;
	top: 0px;
	height: 100%;
	z-index: 1;
	overflow-y: auto;
}

.is-tablet .results { left: 64px; }
.is-mobile .results { left: 0px; }

.results-content {
	width: 100%;
	max-width: 1200px;
	padding: 90px;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}

.is-mobile .results-content { padding: 80px 15px 85px 15px; }

.results-title {
	font-weight: 100;
	font-size: 36px;
	line-height: 36px;
	letter-spacing: 3px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 48px;
}

.results-title:after { content: ' '; position: absolute; bottom: -16px; left: 0px; height: 4px; background-color: var(--aid-color); width: 150px; }

.is-mobile .results-title { font-size: 18px; line-height: 18px; margin-bottom: 32px; }

.results-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 32px; }
.is-mobile .results-intro { font-size: 14px; line-height: 22px; }

.results-section { margin-bottom: 32px; }

.results-section-title { font-size: 20px; font-weight: 600; color: #343434; text-transform: uppercase; margin-bottom: 16px; }

.results-score { text-align: center; padding: 32px; }

.results-score-value { font-size: 65px; font-weight: 600; color: #343434; text-align: center; }
.results-score-value small { font-size: 16px; vertical-align: baseline; margin: 0 10px; }

.results-score-percent { font-size: 14px; color: #343434; text-align: center; letter-spacing: 1px; font-weight: 600; }
.results-score-percent span { font-size: 20px; }

.results-nodata {
	display: flex;
	align-items: flex-start;
	padding: 24px;
	background-color: #f8f8f8;
	border-radius: 12px;
	margin-bottom: 32px;
	font-size: 16px;
	color: #666;
	line-height: 24px;
}

.results-nodata i { color: var(--aid-color); font-size: 20px; margin-right: 16px; margin-top: 2px; flex-shrink: 0; }

.results-explainers { margin-bottom: 32px; }

.results-explainer {
	border-bottom: 1px solid #e0e0e0;
	cursor: pointer;
	transition: background-color 300ms ease-in-out;
}

.results-explainer:first-child { border-top: 1px solid #e0e0e0; }
.results-explainer:hover { background-color: #f8f8f8; }
.results-explainer.is-active { background-color: #f8f8f8; }

.results-explainer-title {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	font-size: 16px;
	font-weight: 600;
	color: #343434;
}

.results-explainer-title i { color: #999; font-size: 12px; }

.results-explainer-text {
	padding: 0 20px 20px;
	font-size: 16px;
	color: #343434;
	line-height: 26px;
	font-weight: 300;
}

.is-mobile .results-explainer-text { font-size: 14px; line-height: 22px; }

.results-explainer-text >>> p { margin-bottom: 8px; }

</style>
